import React from "react";
import NewsletterTwenty from "../component/NewsletterTwenty";

function NewsletterTwentyContainer() {
  return <NewsletterTwenty />;
}

export default NewsletterTwentyContainer;
